import {Component} from "react";
import * as React from "react";

import {WorkUnitStats} from "../models/WorkloadAnalytics";
import * as _ from "lodash";
import Table, {TableColumn} from "./Table";

interface WorkUnitPerformanceListProps
{
    workUnitStats: WorkUnitStats[];
}

interface WorkUnitPerformanceListState
{
    rows?: any[];
}

export default class WorkUnitPerformanceList extends Component<WorkUnitPerformanceListProps,WorkUnitPerformanceListState>
{
    private static columns: TableColumn[] = [
        {
            title: "Name",
            propertyPath: "workUnitName",
            enableSort: true,
            flex: 1
        },
        {
            title: "Failed",
            extraDetail: "With fail result code",
            propertyPath: "failTotal",
            enableSort: true,
            flex: 1,
        },
        {
            title: "Partial Success",
            extraDetail: "With partial success result code",
            propertyPath: "partialSuccessTotal",
            enableSort: true,
            flex: 1
        },
        {
            title: "Success",
            extraDetail: "With success result code",
            propertyPath: "successTotal",
            enableSort: true,
            flex:1
        },
        {
            title: "Total",
            extraDetail: "With any result code",
            propertyPath: "allResultTotal",
            enableSort: true,
            flex: 1
        },
        {
            title: "Average Run Time",
            extraDetail: "With success result code",
            propertyPath: "successAverageRunTime",
            type: "durationSeconds",
            enableSort: true,
            flex: 1
        },
        {
            title: "Success Rate",
            extraDetail: "% with success result code",
            propertyPath: "successPercentage",
            enableSort: true,
            flex:1
        }
    ];

    constructor(props: Readonly<WorkUnitPerformanceListProps>) {
        super(props);

        this.state = {
            rows: undefined
        }
    }

    public componentDidMount() {
        if(this.props.workUnitStats)
        {
            this.setRows();
        }
    }


    componentDidUpdate(prevProps: Readonly<WorkUnitPerformanceListProps>, prevState: Readonly<WorkUnitPerformanceListState>, snapshot?: any): void {
        if(this.props.workUnitStats !== prevProps.workUnitStats)
        {
            this.setRows();
        }
    }

    private setRows()
    {
        if(this.props.workUnitStats)
        {
            const groupedWorkUnitStats: any = _.groupBy(this.props.workUnitStats,(wls: WorkUnitStats) => wls.workUnitName);
            const rows = _.keys(groupedWorkUnitStats).map((workUnitName: string) => {

                const workUnitStats: WorkUnitStats[] = groupedWorkUnitStats[workUnitName];

                const row: any = {
                    workUnitName: workUnitName,
                    failTotal: _.sumBy(workUnitStats,(wls) => wls.failCount),
                    partialSuccessTotal: _.sumBy(workUnitStats,(wls) => wls.partialSuccessCount),
                    successTotal: _.sumBy(workUnitStats,(wls) => wls.successCount),
                    allResultTotal: _.sumBy(workUnitStats,(wls) => wls.allResultCount),
                    successAverageRunTime: _.meanBy(workUnitStats,(wls) => wls.successAverageRunTime)
                }

                row.successPercentage = row.allResultTotal > 0 ? ((row.successTotal / row.allResultTotal) * 100).toFixed(2) : (0).toFixed(2);

                return row;
            });


            this.setState({
                rows
            });
        }
    }

    public render() {

        if(this.state.rows === undefined)
        {
            return null;
        }

        return <Table className={"cdb-table--enable-hover"} title="Work Unit Performance (Sampled Data)" items={this.state.rows} columns={WorkUnitPerformanceList.columns} enableSort={true}/>
    }
}